export default ($timeout) => ({
  scope: false,
  link(scope, element, attr) {
    Object.entries(attr).forEach(([key, value]) => {
      if (isFinite(key)) {
        $timeout(() => scope.$eval(value), key);
      }
    });
  },
});
